import React, {useState} from 'react';
import Style from './Navbar.module.scss';
import Toggler from "./home/Toggler";
import {Link, useLocation} from "react-router-dom";
import {Box} from "@mui/material";
import {info} from "../info/Info";
import Logo from '../img/LOGO.png'
import LogoBlanco from '../img/LOGO_BLANCO.png'


export default function Navbar({darkMode, handleClick}) {
    const location = useLocation()
    const [active, setActive] = useState(location.pathname === '/' ? 'home' : location.pathname.slice(1, location.pathname.length));

    return (
        <Box component={'nav'} width={'100%'}>
            <Box component={'ul'} display={'flex'} justifyContent={'center'} alignItems={'center'}
                 gap={{xs: '2rem', md: '8rem'}}
                 textTransform={'none'} fontSize={'1rem'}>

                       <Box component={'li'} className={active === 'home' ? Style.active : ''}>
                        <Link to='/' onClick={() => setActive('home')}>
                            <p style={{paddingBottom: '0.5rem'}}>Inicio</p>
                        </Link>
                    </Box>

                    <Box component={'li'} className={active === 'about' ? Style.active : ''}>
                        <Link to='/about' onClick={() => setActive('about')}>
                            <p style={{paddingBottom: '0.5rem'}}>acerda de mi</p>
                        </Link>
                    </Box>
                    
                    <Box component={'li'} >
                        <Link to='/' onClick={() => setActive('home')}>
                            <img style={{paddingBottom: '0.5rem', width:'78px'}} src={darkMode ? LogoBlanco : Logo} />
                        </Link>
                    </Box>
                    <Box component={'li'} className={active === 'portfolio' ? Style.active : ''}>
                        <Link to='/portfolio' onClick={() => setActive('portfolio')}>
                            <p style={{paddingBottom: '0.5rem'}}>Proyectos</p>
                        </Link>
                    </Box>

       
                <li>
                    <Toggler darkMode={darkMode} handleClick={handleClick}/>
                </li>
            </Box>
        </Box>
    )
}